// extracted by mini-css-extract-plugin
export default {"wrapper":"eea-z","boldPrefix":"fea-z","link":"gea-z","message":"hea-z","image":"iea-z"};